import { Button, Popover, PopoverTrigger, Stack, Tag, Text } from '@ekhodealer/ekho-common/rev';

import type { DiscountStatusInfo } from '@ekhodealer/ekho-common';

import ChevronDown12 from '@common/components/icons/ChevronDown12';
import { formatTimestampToDate, formatTimestampToTime } from '@common/lib/time';

import { DISCOUNT_STATUS_TAG_CONFIG } from '../types';

export interface StatusCellProps {
	status: DiscountStatusInfo;
}

const PopoverContent = ({ startsAt, endsAt }: { startsAt: number; endsAt: number }) => {
	const startDateFormatted = formatTimestampToDate(startsAt);
	const startTimeFormatted = formatTimestampToTime(startsAt);
	const endDateFormatted = formatTimestampToDate(endsAt);
	const endTimeFormatted = formatTimestampToTime(endsAt);

	const renderDetailStack = (heading: string, detail: string) => (
		<Stack itemsSpacing='8' itemsAlignX='start'>
			<Text size='footnote' weight='semibold'>
				{heading}
			</Text>
			<Text size='bodySmall'>{detail}</Text>
		</Stack>
	);

	return (
		<div style={{ width: 240 }}>
			<Stack itemsSpacing='8' itemsAlignX='start'>
				{startDateFormatted &&
					renderDetailStack('Start date', `${startDateFormatted} ${startTimeFormatted}`)}

				{endDateFormatted &&
					renderDetailStack('End date', `${endDateFormatted} ${endTimeFormatted}`)}
			</Stack>
		</div>
	);
};

export const StatusCell = ({ status }: StatusCellProps) => {
	const config = DISCOUNT_STATUS_TAG_CONFIG[status.value];

	return (
		<PopoverTrigger>
			<Button
				className='status-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<Tag accent={config.accent} size='medium'>
					{config.label}
				</Tag>
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent startsAt={status.startsAt} endsAt={status.endsAt} />
			</Popover>
		</PopoverTrigger>
	);
};
